import { Button } from '../../../component';
import { IMenuItem } from './menuRightSideBar';

interface IItem {
  item: IMenuItem;
  actionMenu: (selectedItem: IMenuItem) => void;
}

function RightSideBarItens({ item, actionMenu }: IItem) {
  const buttonStateValidation = (item: IMenuItem) =>
    item?.activeState ? 'active' : '';

  const disabledButtonOverlayStatus = item?.disabled ? 'active' : '';

  if (!item?.isVisible) return null;

  return (
    <>
      <Button
        id={item.id}
        cy={`ActivateRightMenuMapItem${item.id}`}
        key={item.id}
        className={`${item.class} ${buttonStateValidation(item)}`}
        onClick={() => actionMenu(item)}
        title={item.label}
        disabled={item.disabled}
      >
        <div
          onClick={() => item.disabledAction && item.disabledAction(item)}
          className={`disabled-button-overlay ${disabledButtonOverlayStatus}`}
        ></div>
        {item.icon || null} <span>{item.label}</span>
      </Button>
    </>
  );
}

export default RightSideBarItens;
